import { ReactComponent as Bell } from 'assets/svg/notification-bell.svg';
import { ReactComponent as Calendar } from 'assets/svg/notification-expiry.svg';
import { ReactComponent as Invoice } from 'assets/svg/notification-invoice.svg';
import { ReactComponent as Product } from 'assets/svg/notification-low-stock.svg';
import { ReactComponent as Report } from 'assets/svg/notification-report.svg';
import { ReactComponent as Tax } from 'assets/svg/notification-tax.svg';
import { ReactComponent as Warehouse } from 'assets/svg/notification-warehouse.svg';

export const MARK_READ_EXIT_DURATION = 220;

export const NAVIGABLE_NOTIFICATION_TYPES = ['expiry_lot', 'low_stock', 'storage'];

export const PRODUCT_ID_CANDIDATES = [
  'product_id',
  'productId',
  'product',
  'item_id',
  'itemId',
  'resource_id',
  'resourceId',
];

export const NOTIFICATION_DATA_CONTAINERS = ['data', 'payload', 'meta', 'metadata', 'extra', 'context'];

export const PRODUCT_URL_PARAM_CANDIDATES = ['product_id', 'productId', 'id'];

export const NOTIFICATION_TYPE_FIELDS = ['low_stock', 'out_of_stock', 'expiry_warning', 'expired'];

// Tenant-level reminder shown only to owner/admin; appended to the settings
// fields when the viewer is eligible so cashiers never build or save it.
export const TAX_NOTIFICATION_TYPE_FIELD = 'tax_filing_due';

export const STORAGE_NOTIFICATION_TYPE_FIELD = 'storage_out_of_range';

export const DAV_SYNC_NOTIFICATION_FIELD = 'dav_sync';

export const DAV_SYNC_NOTIFICATION_TYPES = ['dav_sync_failed', 'dav_sync_stale'];

export const STORAGE_BOOK_PATH = '/sop/temperature-humidity';

export const NOTIFICATION_FIELD_FALLBACKS = {
  low_stock: ['low_stock_notifications', 'lowStockNotifications'],
  expiry_warning: ['expiry_lot_notifications', 'expiryLotNotifications'],
};

export const DEFAULT_NOTIFICATION_META = {
  backgroundColor: '#2563EB',
  icon: Bell,
};

export const NOTIFICATION_ICON_MAP = {
  expiry_lot: {
    backgroundColor: '#D97706',
    icon: Calendar,
  },
  invoice: {
    backgroundColor: '#0891B2',
    icon: Invoice,
  },
  low_stock: {
    backgroundColor: '#DC2626',
    icon: Product,
  },
  report: {
    backgroundColor: '#7C3AED',
    icon: Report,
  },
  storage: {
    backgroundColor: '#D97706',
    icon: Warehouse,
  },
  tax: {
    backgroundColor: '#2563EB',
    icon: Tax,
  },
  warehouse: {
    backgroundColor: '#059669',
    icon: Warehouse,
  },
};
